export default "__VITE_ASSET__CGsm_gZ8__"